import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { translate } from 'react-i18next'

import { selectProject } from '../../actions'
import Loading from '../Loading'

import { Menu, Button } from 'antd'

class ProjectsList extends Component {
  render () {
    const { projects, match: { params }, loading, user, t, selectProject } = this.props

    const showAddProjectButton =
      user && (user.isSuperAdmin || (user.companiesRoles && _.includes(user.companiesRoles, 10)))

    if (loading.fetchProjects) return <Loading />

    if (user) {
      return (
        <Menu mode='inline' defaultSelectedKeys={[params.projectId]} onSelect={this.onSelectMenuItem}>

          {projects &&
            _.map(projects, (project, projectId) => (
              <Menu.Item key={projectId}>
                <Link to={`/project/${projectId}`}>{project.name}</Link>
              </Menu.Item>
            ))}

          <Menu.Item disabled>
            {showAddProjectButton &&
              <Button icon='plus' type='primary' onClick={() => selectProject('create')}>
                {t('project.create')}
              </Button>}
          </Menu.Item>

        </Menu>
      )
    }

    return <div style={{ padding: '10px', fontSize: 'small' }}>Projects visible only to logged in users</div>
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  projects: state.projects,
  loading: state.loading,
  user: state.user
})

const mapDispatchToParams = {
  selectProject
}

export default connect(mapStateToProps, mapDispatchToParams)(withRouter(translate('translations')(ProjectsList)))



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectsList.js